module.exports = __webpack_public_path__ + "static/media/eos.8a3cfa39.jpg";